export default {
  empty_list: 'Aún no hay categorías',
  uses_restaurant_open_times: 'Usa los horarios del restaurante',
  products_creation_disabled:
    'Debido a la integración activa con {{integration}}, no se permite crear nuevos productos. Si necesita cambiar el menú, realice los cambios en {{integration}} y sincronice el menú.',
  buttons: {
    add_category: 'Añadir categoría',
  },
  toasts: {
    something_went_wrong: 'Algo salió mal',
  },
};
